<div class="filter-container" [@openClose]="filtersOpened && universalFiltersOpened ? 'open' : 'closed'" (clickOutside)="exitFilter($event)">
  <div class="filter-header">
    <a href="javascript:void(0)" (click)="backToFilters()">
      <i class="material-icons">arrow_back</i>
    </a>
    <div>{{translateFilterName(filter) | translate}}</div>
    <a href="javascript:void(0)" (click)="filtersResign()"><i class="datatable-icon-close"></i></a>
  </div>
  <div class="filter-body">
    <div class="filter-body-item search-field" [class.error]="noValidateNumber">
      <input #itemSearch
             [placeholder]="'SEARCH' | translate"
             [(ngModel)]="name"
             (input)="filterItem(itemSearch.value)"
             class="item-search-input"/>
      <i class="material-icons">search</i>
      <div *ngIf="noValidateNumber" class="number-error-info">{{'ERRORS.PHONE' | translate}}</div>
    </div>
    <div class="filter-body-item" *ngIf="filteredItems && (filteredItems.length > 1)">
      <a href="javascript:void(0)">{{'CONTACTS_LIST.CHOOSE_ALL' | translate}}</a>
      <mat-checkbox
        class="example-margin"
        [(ngModel)]="allChecked"
        [(indeterminate)]="indeterminate"
        (change)="checkAllItem($event)"
        [disabled]="checkboxDisabled">
      </mat-checkbox>
    </div>
    <div class="filter-items-list-wrapper">
      <div class="filter-body-item" *ngFor="let item of filteredItems">
        <span
          [ngClass]="[item.type === 'callerIds' ? ('flag-icon-' + getCountryCode(item.name, item.countryCode)): 'd-none']"
          class="pull-left flag-icon flag"></span>
        <div class="item-number" *ngIf="item.type === 'callerIds'">
          <div class="item-number-label" [title]="item.label">{{item.label}}</div>
          <div class="item-number-name">{{item.name | phoneNumber}}</div>
        </div>
        <a href="#" class="filter-body-item-label" *ngIf="item.type === 'eventTypes' || item.type === 'processingStatuses'" translate>CONTACTS_LIST.STATUS.{{item.name}}</a>
        <a href="#" class="filter-body-item-label" *ngIf="item.type !== 'eventTypes' && item.type !== 'processingStatuses' && item.type !== 'callerIds'">{{item.name}}</a>
        <mat-checkbox
          class="example-margin"
          [(ngModel)]="item.isFilter"
          (change)="toggleFilteringByItem(!!$event.checked, item)">
        </mat-checkbox>
      </div>
    </div>
  </div>
  <div class="filter-footer" (click)="universalFiltersDone()">
    <button class="accept-button" [disabled]="!isFilteringReady">{{'DONE' | translate}}</button>
  </div>
</div>
